import { createSlice } from '@reduxjs/toolkit';
import {CreateCampaignType} from "src/pages/campaings/components/campaigns-main/steps/constants";

export interface IState {
  campaignValue: string;
}
const initialState: IState = {
  campaignValue: CreateCampaignType.priceDiscountInBasket.value,
};

const createCampaign = createSlice({
  name: 'create-campaign',
  initialState,
  reducers: {
    setCampaignValueReducer(state, action) {
      state.campaignValue = action.payload;
    },
  },
});

export const { setCampaignValueReducer } = createCampaign.actions;
export default createCampaign.reducer;
